import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { Observable } from 'rxjs';
import { BaseInputComponent } from '../base-input.component';
import { FloatLabelType, MatFormField } from '@angular/material/form-field';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-form-autocomplete',
    templateUrl: './form-autocomplete.component.html',
    styleUrls: ['./../form-controls.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormAutocompleteComponent extends BaseInputComponent implements AfterViewInit {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public tooltip?: string;
  @Input() public clearable = false;
  @Input() public floatLabel: FloatLabelType = 'auto';
  @Input() public hint: string;
  @Input() public label: string;
  @Input() public prefixIcon: string = null;
  @Input() public suffixIcon: string = null;
  @Input() public placeholder: string;
  @Input() public options$: Observable<any[]>;
  @Input() public displayFn: (value: any) => string;
  @Output() public optionSelected = new EventEmitter<any>();
  @ViewChild(MatFormField) public formField: MatFormField;
  isDisabled = false;
  constructor(protected changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  public ngAfterViewInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
    this.changeDetectorRef.detectChanges();
  }

  public onOptionSelected(option: any): void {
    this.optionSelected.emit(option); // Emit the selected option
  }
}
